<template>
  <router-link class="logo-container" :to="{ name: 'home' }">
    <img src="@/assets/logo.svg" class="logo" alt="Słupska Karta Mieszkańca - Strona główna" />
  </router-link>
</template>

<script>
import { mapState } from 'vuex';

import { config } from '@/utils/config';

// @vuese
// Logo
// @group MainLayout
export default {
  computed: mapState({
    system: state => state.system,
    logoUrl(state) {
      if (state && state.settings.PUBLIC_LOGO && state.settings.PUBLIC_LOGO.value) {
        return `${config.mediaURL}/${state.settings.PUBLIC_LOGO.value}`;
      }
      return '/img/logo.png';
    }
  }),
  beforeCreate() {
    this.$store.dispatch('settings/get', 'PUBLIC_LOGO').catch(err =>
      this.$store.dispatch('notifyError', {
        title: 'Wystąpił błąd podczas pobierania ustawień. Sprawdź połączenie z Internetem',
        messages: [err.message || err]
      })
    );
  }
};
</script>

<style>
.router-link-active {
  text-decoration: none;
}
</style>
